import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./components/ThemeContext";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { AppShell } from "./components/AppShell";
import { AgentSessionProvider } from "./agent/AgentSessionContext";
import { LoginPage } from "./pages/LoginPage";
import { OverviewPage } from "./pages/OverviewPage";
import { OrgDetailPage } from "./pages/OrgDetailPage";
import { DashboardPage } from "./pages/DashboardPage";
import { UsersPage } from "./pages/UsersPage";
import { UserDetailPage } from "./pages/UserDetailPage";
import { MemexDetailPage } from "./pages/MemexDetailPage";
import { CommsPage } from "./pages/CommsPage";
import { ExperimentsPage } from "./pages/ExperimentsPage";
import { AskPage } from "./pages/AskPage";
import { SavedChatsPage } from "./pages/SavedChatsPage";

// Gate: unauthenticated visitors only ever see the SSO login page; an
// authenticated operator gets the shell + routes (ac-6).
function Gated() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-page text-muted">
        Loading…
      </div>
    );
  }
  if (!user) return <LoginPage />;
  return (
    <AgentSessionProvider>
      <AppShell>
        <Routes>
        <Route path="/" element={<OverviewPage />} />
        <Route path="/live" element={<DashboardPage />} />
        <Route path="/ask" element={<AskPage />} />
        <Route path="/ask/saved" element={<SavedChatsPage />} />
        <Route path="/ask/:sessionId" element={<AskPage />} />
        <Route path="/orgs" element={<Navigate to="/" replace />} />
        <Route path="/orgs/:id" element={<OrgDetailPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/users/:id" element={<UserDetailPage />} />
        <Route path="/comms" element={<CommsPage />} />
        <Route path="/experiments" element={<ExperimentsPage />} />
        <Route path="/memexes/:id" element={<MemexDetailPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AppShell>
    </AgentSessionProvider>
  );
}

export function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Gated />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
